import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { GameLogic } from '../../Logic/GameLogic';
import { AnimationContents } from '../../../AnimationContents';

import * as PIXI from 'pixi.js';
import { BonusModel } from '../../Models/Game/BonusModel';

export class UIPointerBonusController extends AnimationBaseController {
    $model: BonusModel;

    private screenWidth: number = 0;
    private screenHeight: number = 0;

    public constructor(@Inject private _options,
                       @Inject private _gameLogic: GameLogic) {
        super('UIPointerBonusController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.POINTER_JSON,
            libraryName: 'pointer',
            modelWatch: {
                screenPos: (value: [number, number]) => {
                    this.updatePosition();
                },
            },
        };
    }

    protected onInitialize(): void {
        this.gotoAndStop(this.$model.type);
        this.updatePosition();
    }

    protected onResize(width: number, height: number, scale: number) {
        this.screenWidth = width;
        this.screenHeight = height;
    }

    protected updatePosition(): void {
        let global = new PIXI.Point(this.$model.screenPos[0], this.$model.screenPos[1]);
        let { x, y } = this.display.parent.toLocal(global, this.renderer.stage);

        const margin = 0;

        let leftTop = this.display.parent.toLocal(new PIXI.Point(margin, margin), this.renderer.stage);
        let rightTop = this.display.parent.toLocal(new PIXI.Point(this.screenWidth - margin, margin), this.renderer.stage);
        let leftBottom = this.display.parent.toLocal(new PIXI.Point(margin, this.screenHeight - margin), this.renderer.stage);

        if (x - this.display.width / 2 < leftBottom.x) {
            x = leftBottom.x + this.display.width / 2;
        }
        if (x + this.display.width / 2 > rightTop.x) {
            x = rightTop.x - this.display.width / 2;
        }
        if (y - this.display.height / 2 < leftTop.y) {
            y = leftTop.y + this.display.height / 2;
        }
        if (y + this.display.height / 2 > leftBottom.y) {
            y = leftBottom.y - this.display.height / 2;
        }

        const a = x - this.display.width / 2 <= leftBottom.x;
        const b = x + this.display.width / 2 >= rightTop.x;
        const c = y - this.display.height / 2 <= leftTop.y;
        const d = y + this.display.height / 2 >= leftBottom.y;

        this.visible = (a || b || c || d);
        this.x = x;
        this.y = y;
    }
}

